import { useEffect, useState } from "react";
import { getOpenStatus } from "../data/site";
import { useLang } from "../i18n";

const KIND_KEY = { today: "status.opensToday", tomorrow: "status.opensTomorrow", sunday: "status.opensSunday" };

export const OpenStatus = ({ className = "" }) => {
  const { t } = useLang();
  const [status, setStatus] = useState(() => getOpenStatus());
  useEffect(() => {
    const t = setInterval(() => setStatus(getOpenStatus()), 60000);
    return () => clearInterval(t);
  }, []);
  const label = status.open
    ? `${t("status.openNow")} · ${t("status.until")} ${status.time}`
    : `${t("status.closed")} · ${t(KIND_KEY[status.kind])} ${status.time}`;
  return (
    <span
      data-testid="open-status-pill"
      className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em] ${
        status.open
          ? "border-accent/40 bg-accent/10 text-accent-bright-deep"
          : "border-ink/20 bg-cream text-ink/70"
      } ${className}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${status.open ? "bg-accent animate-pulse" : "bg-ink/40"}`}
      />
      {label}
    </span>
  );
};
